import React from 'react';
import {connect} from "react-redux";
import {Panel} from 'primereact/components/panel/Panel';
import {Toolbar} from 'primereact/components/toolbar/Toolbar';
import {getReport, getReportPDF, RES_REPORT_UNINVOICED_CHARGES} from "../../../actions/reports";

import {ProgressBar} from "primereact/progressbar";
import {ContextMenu} from "primereact/components/contextmenu/ContextMenu";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {showPatientDetailsPage} from "../PatientDetails/Utils";
import {
    chargeStatusTemplate,
    dateTemplateShort,
    invoiceTemplate,
    placementTemplate,
    ucTPTemplate
} from "../../PatientDynamicItems/Utils";
import {TT_KnowledgeBase, HM_REP_UNINVOICED_CHARGES, JSON_DATE_FORMAT, TB_SAVE_AND_EXIT} from "../../../Constants";
import {ICON_DOWNLOAD, ICON_GOTO, ICON_HELP, ICON_PRINT, ICON_SCREEN,} from "../../../icons";
import _ from "lodash";
import {TabPanel} from "primereact/components/tabview/TabView";
import {ac} from "../../../index";
import {
    HELP_REP_UNINV_CHARGES, setState,
    SM_REPORTS_UNINVOICED_CHARGES,
    SM_REPORTS_UNINVOICED_CHARGES_PDF, stateRequest
} from "../../../actions/stateManagement";
import moment from "moment";
import {TextUninvoicedCharges} from "../../../Messages";
import UninvoicedChargesPDF from "./PDFs/UninvoicedChargesPDF";
import ReportErrorBoundary from "./Utils";
import {tb_boilerPlateRight, tb_boilerPlateRight2} from "../../Utils";
import {PDFBaseComponent} from "../../PDFBaseComponent";
import {PDF_REQUEST_DOWNLOAD, PDF_REQUEST_NONE, PDF_REQUEST_PRINT} from "../../../actions";

const UNINV_COLS = ["", "Date", "Qty", "Code", "Description", "Fee", "Status", "Patient"];

export class ConnectedUninvoicedCharges extends PDFBaseComponent {

    constructor(props) {
        super(props);
        this.state = {
            selectedItem: null,
            rows: 5,
            first: 0,
        };
        this.cm = null;
    }

    componentDidMount() {

        if (!this.props.uninvoicedChargesLoaded) {
            this.props.getReport();
        }
    }

    componentDidUpdate(prevProps, ps, ss) {

        if (this.props.message !== prevProps.message) {

            switch (this.props.message.type) {

                case RES_REPORT_UNINVOICED_CHARGES.PDF.receive:
                    this.setState({
                        pdfBuffer: this.props.pdfBuffer,
                        PDFLoaded: true
                    }, () => {
                        this.props.setState(SM_REPORTS_UNINVOICED_CHARGES.id, this.state);

                        switch (this.state.pdfRequest) {
                            case PDF_REQUEST_PRINT:
                                this.onPrintReport();
                                break;
                            case PDF_REQUEST_DOWNLOAD:
                                this.onDownload();
                                break;
                            default:
                                break;
                        }
                    });
                    break;
                default:
                    break;
            }
        }
    }

    onShowDetails = () => {

        const {patientId, firstName, lastName, gender, nhsPatient, groupId} = this.state.selectedItem;
        showPatientDetailsPage({props: this.props, id: patientId, firstName, lastName, gender, nhsPatient, groupId});
    }

    onShowReport = (event) => {

        const onCloseClick = this.props.onCloseClick;
        const onTabUpdate = this.props.onTabUpdate;

        this.props.onPCButtonClick(
            {
                edited: false,
                content:
                    <TabPanel key={SM_REPORTS_UNINVOICED_CHARGES_PDF.id}
                              header={SM_REPORTS_UNINVOICED_CHARGES_PDF.label}
                              leftIcon={SM_REPORTS_UNINVOICED_CHARGES_PDF.tabIcon}>
                        <UninvoicedChargesPDF onCloseClick={onCloseClick}
                                              onTabUpdate={onTabUpdate}
                                              id={SM_REPORTS_UNINVOICED_CHARGES_PDF.id}/>
                    </TabPanel>,
            }
        )
    }

    onPrintReport = (event) => {

        if (this.state.PDFLoaded) {

            this.setState({pdfRequest: PDF_REQUEST_NONE}, () => {
                super.onPrintReport(`${SM_REPORTS_UNINVOICED_CHARGES_PDF.label} : ${dateTemplateShort(this.state.date)}`);
            })
        } else {
            this.setState({pdfRequest: PDF_REQUEST_PRINT}, () => {
                this.props.getReportPDF({
                    date: moment(this.state.date).format(JSON_DATE_FORMAT)
                });
            })
        }
    }

    onDownload = () => {

        fetch(`https://${ac.getBASERESTURL()}/Reports/uninvoicedCharges.pdf?mcId=${ac.getMcId()}`)
            .then(response => {
                response.blob().then(blob => {
                    let url = window.URL.createObjectURL(blob);
                    let a = document.createElement('a');
                    a.href = url;
                    a.download = `UninvoicedCharges${moment(this.state.date).format('YYYY_MM_DD')}.pdf`;
                    a.click();
                });
            });
    }

    render() {

        if (!this.props.uninvoicedChargesLoaded) {
            return <ProgressBar mode="indeterminate" style={{height: '6px'}}/>;
        }


        const items = [
            {label: 'Show this patients summary', icon: ICON_GOTO, command: this.onShowDetails},
        ];

        const sortedItems = _.sortBy(this.props.uninvoicedCharges, ['id'], ['asc']);

        let key = 1000;

        return (
            <ReportErrorBoundary>
                <div>

                    <Toolbar
                        right={<React.Fragment>
                            {tb_boilerPlateRight2(this.onShowReport, ICON_SCREEN, 'Show ' + HM_REP_UNINVOICED_CHARGES.message, key++, false)}
                            {tb_boilerPlateRight2(this.onPrintReport, ICON_PRINT, 'Print ' + HM_REP_UNINVOICED_CHARGES.message, key++, false)}
                            {tb_boilerPlateRight2(this.onDownload, ICON_DOWNLOAD, `Download ${TextUninvoicedCharges} Report`, key++, false)}
                            {tb_boilerPlateRight(() => window.open(HELP_REP_UNINV_CHARGES), ICON_HELP, TT_KnowledgeBase.label, key++, true)}
                            {tb_boilerPlateRight(this.onExit, TB_SAVE_AND_EXIT.icon, TB_SAVE_AND_EXIT.text, key++)}
                        </React.Fragment>}
                    />

                    <Panel header={HM_REP_UNINVOICED_CHARGES.header} style={{paddingTop: '5px'}}>

                        <ContextMenu model={items}
                                     style={{width: '18em'}}
                                     ref={el => this.cm = el}/>

                        <DataTable value={sortedItems}
                                   className='p-datatable-gridlines'
                                   style={{fontSize: 'small'}}
                                   selectionMode="single"
                                   paginator={true}
                                   rows={this.state.rows}
                                   rowsPerPageOptions={[5, 10, 20]}
                                   onPage={this.onPage}
                                   first={this.state.first}
                                   selection={this.state.selectedItem}
                                   onSelectionChange={(e) => {
                                       this.setState({selectedItem: e.value});
                                   }}
                                   contextMenuSelection={this.state.selectedItem}
                                   onContextMenuSelectionChange={e => this.setState({selectedItem: e.value})}
                                   onContextMenu={e => {
                                       this.cm.show(e.originalEvent);
                                   }}
                        >
                            <Column header={UNINV_COLS[0]}
                                    body={(row) => ucTPTemplate(row.partOfPlan)}
                                    style={{width: '4%'}}/>
                            <Column header={UNINV_COLS[1]}
                                    body={(row) => placementTemplate(row.date)}
                                    style={{width: '10%'}}/>
                            <Column field="qty"
                                    header={UNINV_COLS[2]}
                                    style={{width: '5%', textAlign: 'right'}}/>
                            <Column field="code"
                                    header={UNINV_COLS[3]}
                                    style={{width: '10%'}}/>
                            <Column field="description"
                                    header={UNINV_COLS[4]}
                                    style={{width: '26%'}}/>
                            <Column header={UNINV_COLS[5]}
                                    body={(row) => invoiceTemplate(row.fee, row.qty)}
                                    style={{width: '10%', textAlign: 'right'}}/>
                            <Column header={UNINV_COLS[6]}
                                    body={(row) => chargeStatusTemplate(row.status)}
                                    style={{width: '10%'}}/>
                            <Column field="patientName"
                                    header={UNINV_COLS[7]}
                                    style={{width: '25%'}}/>
                        </DataTable>
                    </Panel>
                </div>
            </ReportErrorBoundary>
        )
    }
}

const mapStateToProps = (state) => {

    console.log(state.reports.uninvoicedChargesPDF);

    return {
        message: state.stateManagement.message,

        uninvoicedChargesLoaded: state.reports.uninvoicedChargesLoaded,
        uninvoicedCharges: state.reports.uninvoicedCharges,

        PDFLoaded: state.reports.uninvoicedChargesPDFLoaded,
        pdfBuffer: state.reports.uninvoicedChargesPDF,
    }
};

const mapDispatchToProps = dispatch => {
    return {

        getReport: () => dispatch(getReport(RES_REPORT_UNINVOICED_CHARGES.GET, null)),
        getReportPDF: (params) => dispatch(getReportPDF(RES_REPORT_UNINVOICED_CHARGES.PDF, params)),

        stateRequest: (source) => dispatch(stateRequest(source)),
        setState: (id, data) => dispatch(setState(id, data)),
    };
};

const UninvoicedCharges = connect(mapStateToProps, mapDispatchToProps)(ConnectedUninvoicedCharges);

export default UninvoicedCharges;
